"use client";

import { useId } from "react";
import { Globe } from "lucide-react";
import { CursorSelect } from "@/desk/components/CursorSelect";
import {
  BILLING_COUNTRY_OPTIONS,
  billingCurrencyFromCountry,
  billingHintFromCountry,
} from "../../../convex/lib/billingRail";

const OPTIONS = BILLING_COUNTRY_OPTIONS.map((row) => ({
  value: row.value,
  label: row.label,
  detail: billingCurrencyFromCountry(row.value),
}));

export function BillingCountrySelect({
  value,
  onChange,
  id,
  leadingIcon = false,
}: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  /** Auth / org pills: one Globe on the trigger, not on every row. */
  leadingIcon?: boolean;
}) {
  const hintId = useId();
  return (
    <div className="studio-billing-country-select" id={id}>
      <CursorSelect
        variant="field"
        align="start"
        ariaLabel="Country"
        describedBy={hintId}
        value={value}
        options={OPTIONS}
        onChange={onChange}
        leading={leadingIcon ? <Globe /> : undefined}
      />
      <span id={hintId} className="studio-settings-field-hint">
        {billingHintFromCountry(value)}
      </span>
    </div>
  );
}
